module.exports = __webpack_public_path__ + "img/projects-details-1.6a99ae89.jpg";